export default {
  "content": "<path d=\"M15.5 19h-7v-2h7v2zM19 13H5v-2h14v2zM22.5 7h-21V5h21v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};